import { Card, Col, Row, Table } from "antd";

export default function TablesWrapper({
  data,
  isLoading,
  tablesPerRow = 2,
  columns,
  tablesName,
}) {
  return (
    <div style={{ width: "85%" }}>
      <Row gutter={16}>
        <Col xs={24} md={24 / tablesPerRow}>
          <Card
            title={tablesName[0]}
            align="center"
            loading={isLoading}
            styles={{
              header: {
                backgroundColor: "#d0d6e2",
              },
            }}>
            <Table
              columns={columns}
              dataSource={data?.["above_mean"]}
              loading={isLoading}
              responsive="stack"
              pagination={{
                pageSize: 10,
              }}
              scroll={{
                y: 360,
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={24 / tablesPerRow}>
          <Card
            title={tablesName[1]}
            align="center"
            loading={isLoading}
            styles={{
              header: {
                backgroundColor: "#d0d6e2",
              },
            }}>
            <Table
              columns={columns}
              dataSource={data?.["below_mean"]}
              responsive="stack"
              pagination={{
                pageSize: 10,
              }}
              scroll={{
                y: 360,
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
